<template>
  <div class="row">
    <rd-column :size="$columns.FullWidth">
      <div class="panel-sysinfo">
        <div class="panel-sysinfo-header">
          {{ title }}
        </div>
        <div class="panel-sysinfo-content">
          <slot name="content"></slot>
        </div>
      </div>
    </rd-column>
  </div>
</template>
<script>
export default {
  name: "SettinsPanel",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.panel-sysinfo {
  background-color: white;
  padding: 2 * $space-size $space-size;
  margin-bottom: $space-size;

  &-header {
    color: #687a8d;
    border-left: 2px solid $primary-color;
    padding-left: $space-size;
    margin-bottom: 2 * $space-size;
  }

  &-content {
    padding-left: $space-size;
  }
}
</style>
